<template>
  <div class="copywriting-page">
    <div style="height: 90%; flex-grow: 1">
      <copywriting-aide ref="copywritingAideRef" />
    </div>
    <div style="text-align: right">
      <el-button
        size="large"
        type="info"
        @click="createdialogSubmitFn('cancel')"
      >
        取消
      </el-button>
      <el-button
        size="large"
        type="primary"
        @click="createdialogSubmitFn('confirm')"
      >
        确 定
      </el-button>
    </div>
  </div>
</template>

<script setup>
import copywritingAide from '@/components/SuperAIHelper/CopywritingAide.vue';
import { ref, onMounted } from 'vue';
import { useMainStore } from '@/pinia/index';
import { StorageUtil } from '@/utils/storageUtil.ts';
import { nextTick } from 'vue';

let tagLocation = window.origin + '/design/#/';

const store = useMainStore();
const copywritingAideRef = ref(null);
const createdialogSubmitFn = (type) => {
  let { content: copywriting } = copywritingAideRef.value.getDataFn();
  StorageUtil.setLocalStorage(
    'designerDatas' + store.userInfo.userId,
    JSON.stringify({ copywriting, close: true, projectId: store.projectId, type })
  );
  window.top.postMessage(JSON.stringify({ copywriting, close: true, projectId: store.projectId, type }), '*');
};

window.addEventListener(
  'message',
  (event) => {
    if (!event.data) return;
    let data;
    try {
      data = JSON.parse(event.data);
    } catch (e) {
      return;
    }
    if (data.origin != 'design') return;
    if (data) {
      let { copywriting = '' } = data;
      copywritingAideRef.value.setContentFn(copywriting);
    }
  },
  false
);

onMounted(() => {
  // let data = StorageUtil.getLocalStorage('designerDatas' + store.userInfo.userId)
  // if (data && copywritingAideRef.value) {
  //   let Resf = copywritingAideRef.value;
  //   let { copywriting = '' } = JSON.parse(data)
  //   Resf.setContentFn(copywriting);
  // }
});
</script>

<style lang="scss" scoped>
.copywriting-page {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
}
</style>
